import React from "react";
import styled from "styled-components";
import LogoImg from "lib/images/loanbossLogoBlack.png";

const LogoRoot = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
    font-family: Work Sans;
    font-size: 11px;
    font-weight: 400;
    line-height: 13px;
    color: #5F6368;
    padding: 1em;
`;

const Logo = styled.img`
    width: 76px;
`;

const PoweredByFooter = () => (
  <LogoRoot>
    <div>Powered by</div>
    <Logo src={LogoImg} alt="LoanBoss-black-logo" />
  </LogoRoot>
);

export default PoweredByFooter;
